import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { position, PositionProps } from 'styled-system';
import anectLogo from '../assets/anect-logo.svg';

interface Props extends PositionProps {
  logo: string | null | undefined;
}

const CompanyLogo = ({ logo, ...props }: Props) => {
  return (
    <Root {...props}>
      {logo != null ? (
        // Use div with background-image because IE doesn't support object-fit but does support background-size
        <div
          css={css`
            width: 110px;
            height: 74px;
            background-image: url(${logo});
            background-size: contain;
            background-repeat: no-repeat;
            background-position: 50% 50%;
          `}
        />
      ) : (
        <img src={anectLogo} alt="" width="110" height="74" />
      )}
    </Root>
  );
};

export default CompanyLogo;

const Root = styled.div(position, {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '8px',
  borderBottomLeftRadius: '5px',
  borderBottomRightRadius: '5px',
});
